<template>
    <painel-component :itens="itensOne">
        <div class="filter-position" v-if="btnFilter">
            <button-one icon="filter" class="btn-filter" @click="filterWindow"/>
        </div>

        <form class="mb-4 mt-5">
            <transition name="fade-in-top">
                <row-component v-if="filter">
                    <row-col-component :class-row-col="'col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12'">
                        <label>Código:</label>
                        <input-component :type-input="'text'" v-model="formDate.code"/>
                    </row-col-component>

                    <row-col-component :class-row-col="'col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12'">
                        <label>Nome:</label>
                        <input-component :type-input="'text'" v-model="formDate.name"/>
                    </row-col-component>

                    <row-col-component :class-row-col="'col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12'">
                        <label>Setor:</label>
                        <multiselect v-model="formDate.sector" :searchable="true" :options="selectSector"
                                     :noResultsText="noResultsText" :noOptionsText="noResultsText"/>
                    </row-col-component>

                    <row-col-component :class-row-col="'col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12'">
                        <label>Status:</label>
                        <multiselect v-model="formDate.status" :searchable="true" :options="SelectNoteStatus"
                                     :noResultsText="noResultsText" :noOptionsText="noResultsText"/>
                    </row-col-component>

                    <row-col-component :class-row-col="'col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12'">
                        <button-one class="mx-1" @submit="submit" :icon="'search'"/>
                        <button-float class="mx-1" :itens="itensTwo"/>
                    </row-col-component>
                </row-component>
            </transition>
        </form>

        <loder-send-component :text-title="'Carregando'" v-if="showLoader"/>

        <div v-else>
            <row-component>
                <row-col-component
                        :class-row-col="'col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-end'">
                    <div class="toggle_preferences">
                        <button :class="{ 'bg-active': parseInt(cardTable) === 1 }" @click="toggleCard" type="button"
                                tooltip="Card">
                            <i class="window maximize outline icon"></i>
                        </button>
                        <button :class="{ 'bg-active': parseInt(cardTable) === 2 }" @click="toggleTable" type="button"
                                tooltip="Tabela">
                            <i class="align justify icon"></i>
                        </button>
                    </div>
                </row-col-component>
            </row-component>

            <row-component v-if="parseInt(cardTable) === 1">
                <row-col-component :class-row-col="'col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12 mt-4'"
                                   v-for="(data, index) in scheduled_note.itens.data" :key="index">
                    <div class="card-container">
                        <div class="flag-status"></div>
                        <p>Código: {{ data.code }}</p>
                        <p>{{ sectorString(data.sector) }}</p>
                        <p class="title-container"><span>{{ data.name }}</span></p>
                        <div class="aux-row-3">
                            <div class="text"><i class="calendar icon"></i>{{ data.date_create }}</div>
                            <div class="text"><i class="clock icon"></i>{{ data.hour_create }}</div>
                        </div>
                        <div class="responsible-task">
                            <article v-if="data.responsibles.length > 0">
                                <p>Responsáveis:</p>
                                <div class="c-profile__list">
                                    <a v-for="(image, index) in data.responsibles" :key="index" class="c-profile"
                                       :data-user="image.user_name"
                                       :style="{ backgroundImage: 'url(' + image.user_photo + ')' }">
                                    </a>
                                </div>
                            </article>
                        </div>
                        <div class="buttons">
                            <button class="primary" tooltip="Editar" @click="routeEdit(data.id)">
                                <i class="edit icon"></i>
                            </button>

                            <button class="primary" tooltip="Ver" @click="routeShow(data.id)">
                                <i class="eye icon"></i>
                            </button>

                            <button class="primary" tooltip="Deletar" @click="deleteSubmit(data)">
                                <i class="trash icon"></i>
                            </button>
                        </div>
                    </div>
                </row-col-component>
            </row-component>

            <table class="table table-striped" v-if="parseInt(cardTable) === 2">
                <thead>
                <tr>
                    <th scope="col" style="width: 10%">Código</th>
                    <th scope="col" style="width: 10%">Responsáveis</th>
                    <th scope="col" style="width: 10%">Nome</th>
                    <th scope="col" style="width: 10%">Setor</th>
                    <th scope="col" style="width: 10%">Data / Hora de Criação</th>
                    <th scope="col" style="width: 10%"
                        v-if="buttonCheck.show || buttonCheck.edit || buttonCheck.delete">
                        Ações
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(data, index) in scheduled_note.itens.data" :key="index">
                    <td data-label="Código">{{ data.code }}</td>
                    <td data-label="Responsáveis">
                        <article v-if="data.responsibles.length > 0">
                            <div class="c-profile__list">
                                <a v-for="(image, index) in data.responsibles" :key="index" class="c-profile"
                                   :data-user="image.user_name"
                                   :style="{ backgroundImage: 'url(' + image.user_photo + ')' }">
                                </a>
                            </div>
                        </article>
                    </td>
                    <td data-label="Nome">{{ data.name }}</td>
                    <td data-label="Setor">{{ sectorString(data.sector) }}</td>
                    <td data-label="Data / Hora de Criação">{{ data.date_create }} / {{ data.hour_create }}</td>
                    <td data-label="Ações" v-if="buttonCheck.show || buttonCheck.edit || buttonCheck.delete">
                        <button tooltip="Ver" class="btn btn-secondary mx-1 button-show" v-if="buttonCheck.show"
                                @click="routeShow(data.id)">
                            <i class="eye icon"></i>
                        </button>

                        <button tooltip="Editar" class="btn btn-success mx-1 button-show" v-if="buttonCheck.edit"
                                @click="routeEdit(data.id)">
                            <i class="edit icon"></i>
                        </button>

                        <button tooltip="Deletar" class="btn btn-danger mx-1 button-show" v-if="buttonCheck.delete"
                                @click="deleteSubmit(data)">
                            <i class="trash icon"></i>
                        </button>
                    </td>
                </tr>
                </tbody>
            </table>

            <button-pagination :pagination="scheduled_note.itens" :offset="3" @paginate="loadScheduledsNotes"/>
        </div>
    </painel-component>
</template>

<script>
import PainelComponent from "@/components/dashboard/PainelComponent";
import ButtonOne from "@/components/buttons/ButtonOne";
import ButtonFloat from "@/components/buttons/ButtonFloat";
import ButtonPagination from "@/components/buttons/ButtonPagination";
import InputComponent from "@/components/form/InputComponent";
import RowComponent from "@/components/row/RowComponent";
import RowColComponent from "@/components/row/RowColComponent";
import LoderSendComponent from "@/components/LoderSendComponent";
import Multiselect from "@vueform/multiselect";
import swal from 'sweetalert';
import {ACTION_MESSAGES} from "@/configs/constants";

import {useToast} from "vue-toastification";

const toast = useToast();

export default {
    name: "ScheduledNoteSearch",
    components: {
        PainelComponent,
        ButtonOne,
        ButtonFloat,
        ButtonPagination,
        InputComponent,
        RowComponent,
        RowColComponent,
        LoderSendComponent,
        Multiselect,
    },

    created() {
        this.$store.dispatch('updateNamePage', 'Anotações Agendadas')
        this.loadScheduledsNotes(1)
        this.resizeWindow()
        this.checkACL()
    },

    data() {
        return {
            itensOne: {
                title: "Pesquisa",
                icon: "list alternate"
            },

            itensTwo: {
                route: "/scheduled-note/create",
                icon: "plus",
                name: ''
            },

            buttonCheck: {
                edit: false,
                create: false,
                show: false,
                delete: false
            },

            formDate: {
                code: '',
                name: '',
                status: '',
                sector: '',
            },

            cardTable: '',
            preferences: {
                type: 14,
                preference: ''
            },

            filter: true,
            btnFilter: false,
            showLoader: true,
            searchSubmit: false,
        }
    },

    methods: {
        submit() {
            this.loadScheduledsNotes(1)
            this.searchSubmit = true;
        },

        loadScheduledsNotes(page) {
            this.showLoader = true
            if (!this.searchSubmit) {
                this.$store.dispatch('loadScheduledsNotes', {...this.params, page})
                    .then((r) => {
                        this.showLoader = false
                        this.cardTable = r.tableCard
                        if (this.searchSubmit) {
                            this.searchSubmit = false;
                            if (r.itens.data.length === 0) {
                                toast.info("Nada foi encontrado com os parâmetros informados!", {timeout: 10000});
                            }
                        }
                    }).catch(() => {
                    this.showLoader = false
                    this.searchSubmit = false;
                });
            }
        },

        deleteSubmit(item) {
            swal({
                title: 'Atenção!',
                text: `Deseja realmente deletar  ${item.name} ?`,
                closeOnClickOutside: false,
                buttons: {
                    cancel: {
                        text: 'Não',
                        visible: true,
                        closeModal: true,
                    },
                    confirm: "Sim"
                }
            }).then((result) => {
                if (result) {
                    this.$store.dispatch('destroyScheduledNote', item.id).then(() => {
                        this.loadScheduledsNotes(1)
                        toast.success(ACTION_MESSAGES.delete, {timeout: 10000});
                    }).catch(() => {
                        toast.error(`Não foi possível deletar  ${item.name} `, {timeout: 10000});
                    })
                }
            });
        },

        async checkACL() {
            this.$store.dispatch('ACLitens', 34)
                .then((r) => {
                    if (r.data.indexOf('note-schedule-search') !== -1) {
                        this.showLoader = false
                        if (r.data.indexOf('note-schedule-search') !== -1) {
                            this.buttonCheck.show = true
                        }

                        if (r.data.indexOf('note-schedule-edit') !== -1) {
                            this.buttonCheck.edit = true
                        }

                        if (r.data.indexOf('note-schedule-create') !== -1) {
                            this.buttonCheck.create = true
                        }

                        if (r.data.indexOf('note-schedule-delete') !== -1) {
                            this.buttonCheck.delete = true
                        }

                    } else {
                        this.$router.push({name: 'home'})
                    }
                }).catch(() => {
                this.$router.push({name: 'home'})
            })
        },

        statusString(value) {
            if (parseInt(value) === 1)
                return 'Aberto'
            return 'Finalizado'
        },

        sectorString(value) {
            if (parseInt(value) === 1)
                return 'Administrativo'
            if (parseInt(value) === 2)
                return 'Criação'
            if (parseInt(value) === 3)
                return 'Comercial'
            if (parseInt(value) === 4)
                return 'Financeiro'
            if (parseInt(value) === 5)
                return 'RH'
            if (parseInt(value) === 6)
                return 'Operacional'
            if (parseInt(value) === 7)
                return 'T.I'
        },

        filterWindow() {
            this.filter = !this.filter
        },

        resizeWindow() {
            if (window.innerWidth <= 991) {
                this.filter = false
                this.btnFilter = true
            } else {
                this.filter = true
                this.btnFilter = false
            }
        },

        routeEdit(id) {
            this.$router.push({name: 'scheduled-note-edit', params: {id: id}})
        },

        routeShow(id) {
            this.$router.push({name: 'scheduled-note-show', params: {id: id}})
        },

        toggleTable() {
            this.userPreferences(2)
            this.cardTable = 2
        },

        toggleCard() {
            this.userPreferences(1)
            this.cardTable = 1
        },

        userPreferences(preference) {
            this.preferences.preference = preference
            this.$store.dispatch('userPreferences', this.preferences)
        },
    },

    computed: {
        noResultsText() {
            return this.$store.state.var.selectNotSearch
        },

        SelectNoteStatus() {
            return this.$store.state.var.SelectNoteStatus;
        },

        selectSector() {
            return this.$store.state.var.selectSector
        },

        scheduled_note() {
            return this.$store.state.scheduled_note.items
        },

        params() {
            return {
                page: this.scheduled_note.current_page,
                code: this.formDate.code,
                name: this.formDate.name,
                status: this.formDate.status,
                sector: this.formDate.sector
            }
        },
    },
}
</script>

<style scoped src="@/assets/css/table-resp.css"></style>
<style scoped>
.toggle_preferences > button {
    border: 0;
    width: 45px;
    color: #fff;
    height: 45px;
    margin: 0 5px;
    border-radius: 50%;
    padding-right: 4px;
    background-color: #323232;
}

.button-show {
    width: 35px;
    height: 35px;
    font-size: 15px;
    border-radius: 50px;
    padding-left: 0.5rem;
}

.bg-active {
    background-color: #d67c1c !important;
}

.c-profile {
    width: 50px;
    height: 50px;
    cursor: pointer;
    border-radius: 50%;
    margin-bottom: 5px;
    display: inline-block;
    border: 4px solid white;
    background: #FFFFFF center center;
    background-size: cover;
    transition: all 200ms ease;
    box-shadow: 0 3px 8px rgba(44, 44, 84, 0.2);
}

.c-profile:nth-of-type(n+2) {
    margin-left: -42px;
}

.c-profile:hover {
    transform: scale(1.2);
    box-shadow: 0 8px 20px rgba(44, 44, 84, 0.2);
}

.c-profile:hover:after {
    top: 35px;
    opacity: 0;
    width: 100px;
    padding: 5px;
    color: #2C3E50;
    font-size: 10px;
    position: absolute;
    border-radius: 0.15rem;
    content: attr(data-user);
    background: rgba(255, 255, 255, 0.95);
    box-shadow: 0 5px 12px rgb(0 0 0 / 12%);
    animation: fade 100ms ease 100ms forwards;
    -webkit-animation: fade 50ms ease 50ms forwards;
}

.c-profile__list {
    z-index: 1;
    width: auto;
    position: relative;
    display: inline-flex;
}

.c-profile__list:hover .c-profile:nth-of-type(n+2) {
    margin-left: 7px;
}

article {
    width: 100%;
    margin-top: 10px;
    max-width: 600px;
}

.card-container {
    display: flex;
    width: 350px;
    color: #2f3032;
    margin: 20px 0;
    max-width: 100%;
    overflow: hidden;
    padding-top: 30px;
    min-height: 317px;
    position: relative;
    text-align: center;
    flex-direction: column;
    background-color: #ffffff;
    border: solid 1px #ededed;
    justify-content: space-evenly;
    box-shadow: 10px 10px 15px rgb(0 0 0 / 35%);
}

.title-container {
    height: 60px;
    padding: 3px 0;
    font-size: 14px;
    font-weight: bold;
    text-transform: uppercase;
}

.card-container h3 {
    color: #424242;
    font-size: 14px;
    font-family: inherit;
    text-transform: uppercase;
}

.card-container > img {
    width: 90px;
    padding: 7px;
    height: 90px;
    margin-top: 25px;
    border-radius: 50%;
    margin-bottom: 10px;
    border: 1px solid #d67c1c;
}

.buttons {
    display: flex;
    min-height: 60px;
    border-top: 1px solid #ededed;
}

button.primary {
    width: 100%;
    height: 60px;
    color: #7e7e7e;
    border: 1px solid #fdfdfd;
    background-color: #f5f5f5;
}

button.primary i {
    color: #7e7e7e;
}

button.primary a {
    color: #7e7e7e;
    padding: 15px 25px;
    text-decoration: none;
}

.responsible-task {
    padding: 15px;
    min-height: 80px;
    text-align: left;
    border-top: 1px solid #ededed;
}

.flag-status {
    top: 0;
    width: 100%;
    color: #ededed;
    font-size: 14px;
    text-align: left;
    position: absolute;
    font-family: 'Comfortaa', sans-serif;
}

.approval-color {
    background-color: #2185d0;
}

.send-color {
    background-color: #16ab39;
}

.aux-row-3 {
    width: 100%;
    display: flex;
    margin-top: 10px;
    align-items: center;
    margin-bottom: 15px;
    justify-content: space-evenly;
}

.aux-row-3 .text > i {
    color: #7e7e7e;
}

@-webkit-keyframes fade {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

@keyframes fade {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}
</style>